import {
  Component,
  effect,
  EventEmitter,
  input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'stc-apps-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss'],
})
export class DropDownComponent {
  data = input.required<any[]>();
  placeholder = input<string>('');
  isReset = input<boolean>(false);
  selectedValue: any | null = null;
  @ViewChild('customeDropdown') dropdown: any;
  @Output() selectedChange = new EventEmitter<string>();
  onCityChange(city: any) {
    this.selectedChange.emit(city.name);
  }
  constructor() {
    effect(() => {
      console.log('isReset value changed:', this.isReset());
      if (this.isReset()) {
        this.selectedValue = null;
      }
    });
  }
}
